export const categories = ["All functions", "CST & pools", "Pipelines & releases", "Alerts & incidents", "Utilities"];

export function isCallableFunction(func) {
    return func.AuthLevel != null && func.AuthLevel !== "function";
}

// Metadata has no category field yet; keep this discovery-only heuristic in one place.
export function getFunctionCategory(func) {
    const name = func.Name.toLowerCase();
    if (/cst|pool|lkg|onebox/.test(name) || /\bleases?\b/.test(formatFunctionName(func.Name).toLowerCase())) return "CST & pools";
    if (/pipeline|build|release|commit|pullrequest/.test(name)) return "Pipelines & releases";
    if (/alert|incident|icm/.test(name)) return "Alerts & incidents";
    return "Utilities";
}

export function formatFunctionName(name) {
    return name.replace(/([a-z0-9])([A-Z])/g, "$1 $2").replace(/([A-Z])([A-Z][a-z])/g, "$1 $2").replace(/_/g, " ")
        .replace(/\b(cst|lkg|icm|ado|api)\b/gi, word => word.toUpperCase());
}

export function matchesFunction(func, query) {
    const text = [func.Name, formatFunctionName(func.Name), func.Description, func.Route, getFunctionCategory(func)].join(" ").toLowerCase();
    return query.trim().toLowerCase().split(/\s+/).every(word => text.includes(word));
}
